"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.genChart = exports.genCharts = exports.genPage = void 0;
var merge_1 = __importDefault(require("lodash/merge"));
var page_1 = __importDefault(require("../constant/page"));
var chart_1 = __importDefault(require("../constant/chart"));
/**
 * 生成页面信息
 * @param page
 */
function genPage(page) {
    return merge_1.default({}, page || {}, page_1.default);
}
exports.genPage = genPage;
/**
 * 生成图标配置信息
 * @param charts
 * @param theme
 */
function genCharts(charts, theme) {
    if (charts === void 0) { charts = []; }
    return charts.map(function (chart) {
        return genChart(chart, theme);
    });
}
exports.genCharts = genCharts;
/**
 * 生成图标配置信息
 * @param charts
 * @param theme
 */
function genChart(chart, theme) {
    if (theme && chart.type && theme[chart.type]) {
        return merge_1.default({}, (chart.type && chart_1.default[chart.type]) || {}, chart, (chart.type && theme[chart.type]) || {});
    }
    else {
        return merge_1.default({}, (chart.type && chart_1.default[chart.type]) || {}, chart);
    }
}
exports.genChart = genChart;
/**
 * 解析编辑器的配置信息 -> echart render 需要的参数
 * @param options
 * @param theme
 */
exports.default = (function (options, theme) {
    return {
        page: genPage(options.page),
        charts: genCharts(options.charts, theme)
    };
});
//# sourceMappingURL=index.js.map